<template>
    <div>
        <Header/>
        <Nav :list="headerList"/>
        <div ref="content">
            <SingleBanner/>
            <div class="page-content">
                <div class="page-content-left">
                    <div class="page-content-left-title">{{aboutxiehuiObj.zjtd.title}}</div>
                    <div class="page-content-left-time">{{aboutxiehuiObj.zjtd.date}}</div>
                    <!-- <div class="page-content-left-content" v-html="ifmExamObj.yjpj.content"></div> -->
                    <div class="page-content-left-content">
                        <div v-for="(item, index) in list" :key="index" class="single">
                            <img :src="item.image">
                            <div class="info">
                                <div class="content" v-html="item.content"></div>
                                <!-- <div class="title">——{{item.title}}</div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page-content-right">
                    <RightTab :list="arr"/>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
import RightTab from './components/rightTab.vue';
import { mapState } from 'vuex'
export default {
    computed: mapState([
        'aboutxiehuiObj'
    ]),
    components:{
       RightTab,
    },
    data() {
        return {
            headerList:[
                {name:'首页', href:'/'},
                {name:'关于协会', href:'/aboutISOC'},
                {name:'专家团队', href:'/ifmDesc'},
            ],
            arr:[
                {name:'IFM简介',url:'/ifmDesc'},
                {name:'理事会成员',url:'/ifmLishihui'},
                {name:'IFM在中国',url:'/ifmInChina'},
                {name:'专家团队',url:'/grop'},
            ],
            list:[
                
            ]
        }
    },
    mounted(){
        this.$http.get('/api/index/getNavNodes',{nodeName:'专家团队'}).then(res => {
            if(res){
                this.list = res;
            }
        })
    },
    methods: {
        
    },
}
</script>
<style lang="scss" scoped>
.single{
    width: 100%;
    margin-bottom: 45px;
    display: flex;
    justify-content: space-between;
    img{
        display: block;
        width: 100px;
        height: 127px;
        box-shadow: 10px 10px 5px #888888;
    }
    .info{
        width:700px;
        padding-right: 40px;
        box-sizing: border-box;
        .content{
            font-size: 14px;
            color: #3B3B3B;
            letter-spacing: 0.4px;
            line-height: 22px;
            font-weight: 400;
        }
        .title{
            font-size: 14px;
            color: #3B3B3B;
            margin-top: 10px;
            letter-spacing: 0.4px;
            line-height: 22px;
            font-weight: 600;
        }
    }
}
</style>
